import { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Divider, styled, Typography } from '@mui/material';
import Image from '../Image';

import bg from '../../assets/images/bg/wave.png';
import loginimage from '../../assets/images/bg/loginimage.png';
import crossed from '../../assets/images/hand/crossed.png';
import shake from '../../assets/images/hand/shake.png';
import ok from '../../assets/images/hand/ok.png';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import Footer from './footer';
import ScrollToTop from '../ScrollToTop';

const LinearView = styled(Box)(({ theme }) => ({
    minHeight: '100vh',
    background: 'linear-gradient(to right bottom, #003366, #2AB1BF)',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    width: '50%',
    // maxWidth: "750px",
    [theme.breakpoints.up('lg')]: {
        padding: '70px',
    },
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));

const BlurBox = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    background: 'rgba(26, 26, 26, 0.4)',
    opacity: 1,
    borderRadius: 25,
    backdropFilter: 'blur(22px)',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: "column",
    padding: '30px',
    gap: "30px",
    justifyContent: "space-between",
    [theme.breakpoints.up('lg')]: {
        padding: '50px',
    },
}));

const IconBox = styled(Box)(({ theme }) => ({
    height: "70px",
    width: "70px",
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
}));


const AuthLayout = memo(({ children }) => {
    const { t } = useTranslation();
    const { auth } = useAuth();

    if (auth.isAuthenticated) {
        return <Navigate to="/" />;
    }


    return (
        <ScrollToTop>
            <Box key="layout" sx={{ display: 'flex', minHeight: '100vh', background: (theme) => theme.palette.background.paper }} >
                <LinearView >
                    <Image src={bg} style={{ position: 'absolute', width: '100%', height: '100%' }} />
                    <BlurBox >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: .5, width: '100%' }}>
                            <Typography variant="h4" color="#FFFFFF" fontWeight="500">{t('auth.welcomeMessage1')}</Typography>
                            <Typography variant="h4" color="#FFFFFF" fontWeight="500" alignItems="center" display="flex" >{t('auth.welcomeMessage2')} <Image src={crossed} /></Typography>
                            <Typography variant="h4" color="#FFFFFF" fontWeight="500">{t('auth.welcomeMessage3')}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: "50px", width: '100%', alignItems: "center" }}>
                            <Divider sx={{ width: '20%', alignSelf: "flex-start", opacity: 0.4 }} color="#FFFFFF" />
                            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', maxWidth: { xs: "400px", xll: "600px" }, alignItems: "center" }}>
                                <Image src={loginimage} style={{ width: '100%' }} />
                            </Box>
                            <Divider sx={{ width: '20%', alignSelf: "flex-start", opacity: 0.4 }} color="#FFFFFF" />
                        </Box>
                        <IconBox sx={{ top: "120px", right: "-32.5px" }}>
                            <Image src={ok} style={{ width: '50%', }} />
                        </IconBox>
                        <IconBox sx={{ bottom: "120px", left: "-32.5px" }}>
                            <Image src={shake} style={{ width: '50%', }} />
                        </IconBox>
                    </BlurBox>
                </LinearView>
                <Box sx={{ flexGrow: 1 }}>
                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', height: "calc(100vh - 55px)" }}>
                        {children}
                    </Box>
                    <Footer key="footer" sx={{ paddingX: "20px" }} />
                </Box>
            </Box>
        </ScrollToTop>
    );
});

AuthLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AuthLayout;